var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4F4F4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1748 15.2729C10.1748 14.2749 10.2876 13.4888 10.5132 12.9146C10.7388 12.3335 11.1045 11.8311 11.6104 11.4072C12.1162 10.9834 12.499 10.5972 12.7588 10.2485C13.0254 9.89307 13.1587 9.50342 13.1587 9.07959C13.1587 8.04736 12.7144 7.53125 11.8257 7.53125C11.4155 7.53125 11.084 7.68164 10.8311 7.98242C10.5781 8.2832 10.4448 8.68994 10.4312 9.20264H6.96533C6.979 7.83545 7.40967 6.77246 8.25732 6.01367C9.10498 5.24805 10.2944 4.86523 11.8257 4.86523C13.3501 4.86523 14.5293 5.21729 15.3633 5.92139C16.2041 6.62549 16.6245 7.62695 16.6245 8.92578C16.6245 9.49316 16.5117 10.0093 16.2861 10.4741C16.0605 10.939 15.6982 11.4141 15.1992 11.8994L14.02 12.9966C13.6851 13.3179 13.4526 13.6494 13.3228 13.9912C13.1929 14.3262 13.1211 14.7534 13.1074 15.2729H10.1748ZM9.75439 18.3901C9.75439 17.8843 9.93555 17.4707 10.2979 17.1494C10.667 16.8213 11.125 16.6572 11.6719 16.6572C12.2188 16.6572 12.6733 16.8213 13.0356 17.1494C13.4048 17.4707 13.5894 17.8843 13.5894 18.3901C13.5894 18.896 13.4048 19.313 13.0356 19.6411C12.6733 19.9624 12.2188 20.123 11.6719 20.123C11.125 20.123 10.667 19.9624 10.2979 19.6411C9.93555 19.313 9.75439 18.896 9.75439 18.3901Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.3137afaec36a6babafb95f7543d2f25d.svg";
export { ForwardRef as ReactComponent };